import React, { ReactElement, useState } from 'react'
import TabTitle from './TabTitle'

type Props = {
  children: ReactElement[]
  lazy?: boolean
}

const Tabs: React.FC<Props> = ({ children, lazy = false }) => {
  const [selectedTab, setSelectedTab] = useState(0)
  const [visitedTabs, setVisitedTabs] = useState<Set<number>>(new Set([0]))
  // remove undefined keys
  children = children.filter(element => element !== undefined)

  const handleSetSelectedTab = (index: number) => {
    setSelectedTab(index)
    if (lazy) setVisitedTabs(prev => new Set(prev).add(index))
  }

  return (
    <div>
      <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
        {children.map((item, index) => (
          <TabTitle
            key={index}
            active={index === selectedTab}
            title={item?.props?.title}
            index={index}
            setSelectedTab={handleSetSelectedTab}
          />
        ))}
      </ul>
      <div className="card mb-5 mb-xl-10">
        {React.Children.map(children, (child, index) => {
          if (React.isValidElement(child)) {
            if (lazy && !visitedTabs.has(index)) return null
            return (
              <div
                style={{
                  display: child.key === String(selectedTab) ? 'block' : 'none'
                }}
              >
                {React.cloneElement(child)}
              </div>
            )
          }
        })}
      </div>
    </div>
  )
}

export default Tabs
